module.exports = __webpack_public_path__ + "static/media/select_all_icon.f0a18ac3.svg";